export const mutations = {
  SET_EXPAND_LIST: 'SET_EXPAND_LIST',
  SET_SEARCH_BY: 'SET_SEARCH_BY',
  SET_PAGE_ID: 'SET_PAGE_ID',
  SET_FETCHED_ALL: 'SET_FETCHED_ALL',
  SET_FETCHED_ALL_QUERY: 'SET_FETCHED_ALL_QUERY',
  SET_ASSIGNED_PRODUCT: 'SET_ASSIGNED_PRODUCT',
  UPDATE_ASSIGNED_PRODUCT: 'UPDATE_ASSIGNED_PRODUCT',
  SET_SELECT_ALL: 'SET_SELECT_ALL',
  RESET_SEARCH_RESULT: 'RESET_SEARCH_RESULT',
  RESET_PRODUCT_DATA: 'RESET_PRODUCT_DATA',
  REFRESH_PRODUCT_DATA: 'REFRESH_PRODUCT_DATA',
  REFRESH_PRODUCT_QUERY_DATA: 'REFRESH_PRODUCT_QUERY_DATA',
  RESET_SELECT_PRODUCT: 'RESET_SELECT_PRODUCT',
  RESET_SELECT_BY_FILTER: 'RESET_SELECT_BY_FILTER',
};

export const actions = {
  GET_PRODUCTS: 'getProducts',
  GET_LIST_BY_FILTER: 'getListByFilter',
  GET_PRODUCTS_BY_FILTER: 'getProductsByFilter',
  UPDATE_PAGE_ASSIGNMENT: 'updatePageAssignment',
};

export const getters = {
};
